import React from 'react';
import {
    Button,
    Form,
    Header,
    Segment,
    Input,
    Popup,
    Loader,
    Table,
    Divider,
    Checkbox,
    Icon,
    Message
} from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';
import { Redirect } from 'react-router';
import Modal from 'react-responsive-modal';

import { ToastContainer, toast } from 'react-toastify';


import AddNewPerson from './AddNewPerson';
import { FiltersOnStyle, HeaderCursor, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import SimpleTwoColumnTableRow from '../../StudentService/StudentOverview/NextSemesterEnroll';


export default class CheckPersonAndEmployee extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            jmbg: null,

            persons: [],
            employees: [],

            showPersonsTable: false,
            showEmployeeTable: false,


            showProfile: false,
            addNewPerson: false,
            addNewEmployeeForPerson: false,
            open: false,
            academicStaff: true,
            nonacademicStaff: false,

            associate: false

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.checkEmployee = this.checkEmployee.bind(this);
        this.checkPerson = this.checkPerson.bind(this);
    }

    componentDidMount() {
        window.localStorage.removeItem('person');
        window.localStorage.removeItem('employee');
        window.localStorage.removeItem('main');
        window.localStorage.removeItem('orgUnit');
        window.localStorage.removeItem('semester');
        window.localStorage.removeItem('academicYear');
        window.localStorage.removeItem('academicStaff');
    }

    checkEmployee() {
        let obj = {
            jmbg: this.state.jmbg,
            employeeTypeId:
                localStorage.getItem('osoblje') === 'nastavno' ? 1 :
                    localStorage.getItem('osoblje') === 'nenastavno' ? 2 : '',

            associateStaff: localStorage.getItem('osoblje') === 'angažovano'
        };

        axios.post('hr/get-employee-by-jmbg/', { ...obj })
            .then(res => {
                if (res.data.length > 1) {
                    this.setState({ employees: res.data, showPersonsTable: false, showEmployeeTable: true });
                    res.data[0].associateStaff ? localStorage.setItem('associate', 'true') : localStorage.setItem('associate', 'false');

                    axios.post('employees/by-organizational-unit', { ...obj })
                        .then(r => {
                            if (r.data.length) {
                                localStorage.setItem('main', r.data[0].main);
                            } else {
                                localStorage.setItem('main', 'false');
                            }
                        });
                } if (res.data.length === 1) {
                    if (res.data[0].associateStaff === true) localStorage.setItem('associate', 'true'); else localStorage.setItem('associate', 'false');
                    localStorage.setItem('employee', JSON.stringify(res.data[0]));
                    if (res.data[0].employeeType._key === 'nastavno osoblje') localStorage.setItem('academicStaff', 'true');
                    if (res.data[0].employeeType._key === 'nenastavno osoblje') localStorage.setItem('academicStaff', 'false');

                    //    check if orgUnit is main
                    axios.post('employees/by-organizational-unit', { ...obj })
                        .then(r => {
                            if (r.data.length) {
                                localStorage.setItem('main', r.data[0].main);
                                this.setState({ showProfile: true });
                            } else {
                                localStorage.setItem('main', 'false');
                                this.setState({ showProfile: true });
                            }
                        });
                }
                if (!res.data.length) {
                    this.setState({ addNewEmployeeForPerson: true });
                    localStorage.setItem('academicStaff', 'none');
                }
            })
            .catch(err => {
                // toast('Provjera za zaposlenika nije uspješno izvršena.');
            });
    }


    checkPerson() {
        let obj = {
            jmbg: this.state.jmbg
        };
        axios.post('hr/get-person-by-jmbg/', { ...obj })
            .then(res => {
                if (res.data.length === 1) {
                    localStorage.setItem('person', JSON.stringify(res.data[0]));
                    this.setState({ persons: res.data });
                    this.checkEmployee();
                }
                if (res.data.length > 1) {
                    this.setState({ persons: res.data, showPersonsTable: true });
                }
                if (!res.data.length) {
                    this.setState({ open: true });
                }
            })
            .catch(err => {
                // toast('Provjera za osobu nije uspješno izvršena.');
            });
    }

    handleInputChange(e, { name, value }) {
        this.setState({ [name]: value });
    }


    render() {
        if (this.state.showProfile) return <Redirect push to={{ pathname: '/pretraga-i-unos-osobe/informacije-o-zaposleniku' }} />;
        if (this.state.addNewPerson) return <Redirect push to={{ pathname: '/pretraga-i-unos-osobe/dodavanje-osobe', state: { jmbg: this.state.jmbg } }} />;
        if (this.state.addNewEmployeeForPerson) return <Redirect push to={{ pathname: '/pretraga-i-unos-osobe/dodavanje-zaposlenika' }} />;
        return (
            <div>

                <Modal
                    open={this.state.open}
                    onClose={() => this.setState({ open: false })}
                    center
                ><br />
                    <Segment.Group raised>
                        <Segment>
                            Uneseni JMBG: <b>{this.state.jmbg}</b>
                        </Segment>
                        <Segment clearing>
                            Osoba sa unesenim JMBG-om ne postoji u sistemu. <br /><br />

                            Da li je zaposlenik spoljni saradnik / angažovano osoblje?<br /><br />
                            <Checkbox
                                radio
                                checked={this.state.associate}
                                label={<label>Da</label>}
                                value={this.state.associate}
                                onChange={(e) => this.setState({ associate: true })}
                            />
                            <br />
                            <Checkbox
                                radio
                                checked={!this.state.associate}
                                label={<label>Ne</label>}
                                value={this.state.associate}
                                onChange={(e) => this.setState({ associate: false })}
                            />

                            <br /><br />

                            Zaposlenik je:<br /><br />

                            <Checkbox
                                radio
                                checked={this.state.academicStaff}
                                label={<label>Nastavno osoblje / naučno-istraživačko osoblje</label>}
                                value={this.state.academicStaff}
                                onChange={(e) => this.setState({ academicStaff: !this.state.academicStaff, nonacademicStaff: false })}
                            />

                            <br />
                            <Checkbox
                                radio
                                checked={this.state.nonacademicStaff}
                                label={<label>Nenastavno</label>}
                                value={this.state.nonacademicStaff}
                                onChange={(e) => this.setState({ nonacademicStaff: !this.state.nonacademicStaff, academicStaff: false })}
                            />
                            <br />
                            <br />


                            <br />


                            <Button floated="right" color="blue" basic="true" onClick={() => this.setState({ open: false })}>Odustani</Button>
                            <Button
                                floated="right"
                                color="blue"
                                onClick={() => {
                                    this.setState({ addNewPerson: true });
                                    localStorage.setItem('academicStaff', this.state.academicStaff);
                                    localStorage.setItem('associate', this.state.associate ? 'true' : 'false');
                                }}
                            >
                                Kreiraj zaposlenika</Button>
                        </Segment>
                    </Segment.Group>
                </Modal>

                <Header as="h1"> Pretraga i unos osobe </Header>


                <Segment.Group raised >

                    <Segment>

                        <Header as="h3">
                            <Header style={IconHeader} floated="right" >
                                <Icon />
                                <Popup
                                    trigger={<Icon link circular basic="true" floated="right" name="info" />}
                                    content="Ukoliko osoba sa unesenim JMBG-om postoji u sistemu otvorit će Vam se njegovi/njeni podaci. Ukoliko te osobe nema u sistemu,
                            otvorit će se forma za unos nove osobe. Također, osoba može biti unesena u sistem, a da joj nedostaju podaci o zaposlenju, pa će Vam sistem tražiti samo unos podataka o zaposlenju."
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                            Pretraga osobe po JMBG-u
                        </Header>
                    </Segment>

                    <Segment clearing>

                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field
                                    required
                                    control={Input}
                                    label="JMBG"
                                    placeholder="JMBG"
                                    value={this.state.jmbg}
                                    name="jmbg"
                                    onChange={this.handleInputChange}
                                    error={this.state.jmbgErr}
                                />
                                <Form.Button label=" " color="blue" basic="true" onClick={this.checkPerson}>Dalje</Form.Button>
                            </Form.Group>
                        </Form>


                        {/* <Segment clearing> */}
                        {/* <span style={{fontSize: '13px', fontWeight: 'normal'}}><i>Za strane državljane koji nemaju JMBG</i></span> */}
                        {/* <Form> */}
                        {/* <Form.Group widths="equal"> */}
                        {/* <Form.Field */}
                        {/* required */}
                        {/* control={Input} */}
                        {/* label="JMBG" */}
                        {/* placeholder="JMBG" */}
                        {/* value={this.state.jmbg} */}
                        {/* name="jmbg" */}
                        {/* onChange={this.handleInputChange} */}
                        {/* error={this.state.jmbgErr} */}
                        {/* /> */}
                        {/* <Form.Button label=" " color="blue" basic="true" onClick={this.checkPerson}>Dalje</Form.Button> */}
                        {/* </Form.Group> */}
                        {/* </Form> */}

                        {/* </Segment> */}


                        {this.state.showPersonsTable &&
                        <div>
                            <br />
                            <Divider horizontal>
                                <Header as="h4">Spisak osoba sa traženim JMBG-om</Header>
                            </Divider>
                            <Table celled selectable compact >
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Prezime</Table.HeaderCell>
                                        <Table.HeaderCell>Ime</Table.HeaderCell>
                                        <Table.HeaderCell>Datum rođenja</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body> {this.state.persons.map((el, index) =>
                                    (<Popup
                                        trigger={<Table.Row key={index} style={HeaderCursor} onClick={() => { this.checkEmployee(); localStorage.setItem('person', JSON.stringify(el)); }}>
                                            <Table.Cell verticalAlign="middle">
                                                {el.lastName}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {el.firstName}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {el.dateOfBirth && moment(el.dateOfBirth).format('D. M. YYYY.')}
                                            </Table.Cell>
                                        </Table.Row>}
                                        content="Prikaz / dodavanje zaposlenja"
                                        hideOnScroll
                                        position="left center"
                                    />))}
                                </Table.Body>
                            </Table>
                        </div>}

                        {this.state.showEmployeeTable &&
                        <div>
                            <br />
                            <Divider horizontal>
                                <Header as="h4">Spisak zaposlenika sa traženim JMBG-om</Header>
                            </Divider>

                            <Table celled selectable compact >
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Prezime</Table.HeaderCell>
                                        <Table.HeaderCell>Ime</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body> {this.state.employees.map((el, index) =>
                                    (<Popup
                                        trigger={<Table.Row key={index} style={HeaderCursor} onClick={() => { this.setState({ showProfile: true }); localStorage.setItem('employee', JSON.stringify(el)); }}>
                                            <Table.Cell verticalAlign="middle">
                                                {el.person.lastName}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {el.person.firstName}
                                            </Table.Cell>

                                        </Table.Row>}
                                        content="Prikaz / dodavanje zaposlenja"
                                        hideOnScroll
                                        position="left center"
                                    />))}
                                </Table.Body>
                            </Table>
                        </div>}
                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/views/HR/add/CheckPersonAndEmployee.js